import { Component, HostBinding, Input } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-icon",
  templateUrl: "./icon.component.html",
  styleUrls: ["./icon.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class IconComponent {
  @Input() name: string = ""; // e.g. "arrow-right", "home", "user"
  @Input() color: string = "currentColor";
  @Input() size: number = 24;
  @Input() strokeWidth: number = 2;
  @Input() style: string = "";
  @Input() class: string = "";

  @HostBinding("style.width.px")
  @HostBinding("style.height.px")
  get hostSize(): number {
    return this.size;
  }

  @HostBinding("style.display")
  display = "inline-flex";

  @HostBinding("style.line-height")
  lineHeight = "0";

  @HostBinding("style.vertical-align")
  verticalAlign = "middle";
}
